import { useContext } from "react";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";
import { useAppSelector } from "../../../utils/hooks/store";
import LoadingIcon from "../../common/LoadingIcon";
import RevisionsTool from "./RevisionsTool";
import { useBoard } from "../../../utils/hooks/commonly-stored/uploaded-board/board";

export default function Revisions() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const revisions = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.boardRevisions || null,
  );

  const { board: previousRevision } = useBoard(
    revisions?.previous_revision_id || null,
  );

  if (
    revisions === null ||
    (revisions.previous_revision_id !== null && previousRevision === null)
  ) {
    return <LoadingIcon text={"Loading revisions"} />;
  }

  return (
    <RevisionsTool revisions={revisions} previousRevision={previousRevision} />
  );
}
